export const ChildValidationSchema = (json) => {     
  const MyPromiss = new Promise((resolve, reject) => {       
    var errorJson = {};          
    
    // Helper function to safely handle string operations       
    const safeStringTrim = (value) => {         
      if (value === null || value === undefined) return '';         
      return typeof value === 'string' ? value.trim() : String(value).trim();       
    };          
    
    // Required fields validation       
    if (!json?.name || safeStringTrim(json.name) === "") {         
      Object.assign(errorJson, { name: "Service name cannot be empty *" });       
    }                         
    
    // Price validation       
    if (!json?.price || json.price === "") {         
      Object.assign(errorJson, { price: "Regular price cannot be empty *" });       
    } else if (isNaN(json.price) || parseFloat(json.price) < 0) {         
      Object.assign(errorJson, { price: "Price must be a valid positive number *" });       
    }
    
    // Incentive validation
    if (json?.incentive !== undefined && json.incentive !== null && json.incentive !== "") {
      if (isNaN(json.incentive) || parseFloat(json.incentive) < 0) {
        Object.assign(errorJson, { incentive: "Incentive must be a valid positive number *" });
      } else if (parseFloat(json.incentive) > 35) {
        Object.assign(errorJson, { incentive: "Incentive cannot be more than 35 *" });
      }
    }
               
    resolve(errorJson);     
  });        
  
  return MyPromiss;   
};